module.exports = __webpack_public_path__ + "img/mntn_01.dcd019cd.svg";